import axios from "axios";
import { store } from "../store";
import config from "../config";
import authHeader from "./auth-header";
import { buildCampaignOptionRequest, buildCampaignViewRequest } from "./contentContract";

const API_URL = config.API_URL;

const create = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value]);
  }
  const action = "afterlogin/reviewcampaign/store";
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const update = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const clickEvent = values && values.clickEvent;
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value] ? values[value] : "");
  }
  let action = "afterlogin/reviewcampaign/update/" + values.id;
  if (clickEvent && clickEvent === "statusupdate") {
    // A toggle is a request to SET the state. Serialising a falsy state as ""
    // let the Flask route fall back to flipping the column, so "disable" on an
    // already-disabled campaign re-enabled it (SOF-426 issue 40).
    action = "afterlogin/reviewcampaign/isactive/" + values.id;
    formData.set("is_active", values.is_active ? "1" : "0");
  }
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const view = (values) => {
  const request = buildCampaignViewRequest("afterlogin/reviewcampaign/view", values);
  return axios.post(API_URL + request.url, request.body, { headers: authHeader() });
};

const deleted = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/reviewcampaign/delete/${values.id}`;
  const data = {
    auth_key: auth_key,
    action: action,
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};

const services = (values) => {
  const request = buildCampaignOptionRequest("afterlogin/reviewcampaign/services", values);
  return axios.post(API_URL + request.url, request.body, { headers: authHeader() });
};

const sendemail = (values) => {
  const auth = store.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = "afterlogin/reviewcampaign/sendemail";
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value] ? values[value] : "");
  }
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: authHeader({ contentType: "multipart/form-data" }) });
};

const ReviewCampaignApiController = {
  create,
  update,
  view,
  deleted,
  services,
  sendemail,
};
export default ReviewCampaignApiController;
